import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'
import { SystemCode } from '@/api'

export interface BibliographySetCreateRequest {
  searchType: SystemCode
  bibliographySetId?: number
  details: BibliographyTagRegisterData[]
}

export function BibliographySetCreateRequestToJSON(
  value: BibliographySetCreateRequest
): any {
  return {
    search_type: value.searchType.code,
    bibliography_set_id: value.bibliographySetId ?? undefined,
    details: value.details.map(BibliographyTagRegisterDataToJSON)
  }
}
